import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=e784b1a6&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=ts"
export * from "./TabBar.vue?vue&type=script&lang=ts"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=e784b1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e784b1a6",
  null
  
)

export default component.exports